import { render, staticRenderFns } from "./RatedJoint.vue?vue&type=template&id=95fef050&scoped=true&"
import script from "./RatedJoint.vue?vue&type=script&lang=js&"
export * from "./RatedJoint.vue?vue&type=script&lang=js&"
import style0 from "./RatedJoint.vue?vue&type=style&index=0&id=95fef050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fef050",
  null
  
)

export default component.exports